module.exports = __webpack_public_path__ + "img/inside-front.8cd94bd4.svg";